import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Create,
    GetAllPoolName
} from "adminApi/PoolPackageApi/PoolPackage.js";
import { validateForm } from "utils/validation";
import { PoolPackageRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/PoolPackageFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import AddPoolPackageForm from "./components/AddPoolPackageForm";
import useFetchAllData from "Hooks/useFetchAllData";

const AddPoolPoolPackage = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(initialValues, PoolPackageRules);

    const { data: PooNameOptions } = useFetchAllData(GetAllPoolName);

    // Form submit hook
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Create({ data: formData });
        },
        (vals) => {
            const err = validateForm(vals, PoolPackageRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Pool Package Created successfully"
    );
    return (
        <>
            {(loadingSubmit) && <Spinner isSpinner={true} />}
            <AddPoolPackageForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Create Pool Package"
                handleFileChange={handleFileChange}
                imagePreview={values.pool_package_imagePreview || values.pool_package_image}
                PooNameOptions={PooNameOptions}
            />
        </>
    );
};

export default AddPoolPoolPackage;